import { Form } from "antd";
import FormInput from "component/form/form_input";
import React, { useState } from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const WithdrawBankFullName = () => {
  // -------------------------- VAR -----------------------------
  const form = Form?.useFormInstance();
  const code = Form?.useWatch("code", form) || null;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!code) return null;
  return (
    <FormInput
      name="accountName"
      label="Tên người nhận"
      placeholder="Nhập tên người nhận"
      variant="filled"
      style={{ minHeight: 40 }}
      rules={[
        {
          required: true,
          message: "Làm ơn nhập tên người nhận",
        },
      ]}
    />
  );
};
export default WithdrawBankFullName;
